import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ui-bordered-control-wrapper',
    imports: [CommonModule],
    templateUrl: './control-bordered-wrapper.component.html',
    styleUrls: ['./control-bordered-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlBorderedWrapperComponent {
  @Input() invalid = false;
  @Input() disabled = false;
  @Input() size: 'regular' | 'large' = 'regular';
}
